import { ndcAllowedRoles } from 'data/facts/userRolesValidations';
import { useStore } from 'hooks/useStore';
import { NDCTableInstanceInterfce } from 'Interfaces/FactsInterfaces/drugInterfaces';
import { useState } from 'react';
import { checkIfFunctionalityEnabled } from 'utils/facts/roleBasedFunctionalityAccess';

export const useNdcStrategyTable = () => {
  const {
    UserStore: { userModulesRoles },
    FactsStore: {
      isNdcStrategyModalVisible,
      isConceptsListLoading,
      isBulkEditModalVisible,
      selectedContractAccordionIndex,
      setSelectedContractAccordionIndex,
      handleSetNdcStrategyIndexes,
      selectedNdcSectionContractNumber,
      handleSetSelectedSectionContractNumber,
      toggleNdcBulkEditStrategyModal,
      resetNdcSelectedIndexes,
      ndcSections,
      ndcTablesData,
      isNcdTableLoading,
      selectedNdcStrategyIndexesForEdit,
      addNdcIndexForMultiEdit,
      handleEditSingleNdcStrategy,
      handleViewSingleNdcStrategy,
      handleAddSingleNdcStrategy,
      toggleNdcStrategyModalVisibility,
      checkIfNdcIndexIsSelected,
      isNDCAddVisible,
      isNDCViewVisible,
      toggleNDCAddModalVisibility,
      toggleNDCViewModalVisibility,
    },
  } = useStore();
  const [, setIsAllSelected] = useState(false);
  const columnDetails = [
    {
      label: 'NDC',
      key: 'ndc',
      width: '7%',
    },
    {
      label: 'Pack Size',
      key: 'packSize',
      width: '10%',
    },
    {
      label: 'Supplier Name',
      key: 'suppliername',
      width: '15%',
    },
    {
      label: 'Price',
      key: 'price',
      width: '5%',
    },
    {
      label: 'PPS',
      key: 'pps',
      width: '12%',
    },

    {
      label: 'PPS Reason',
      key: 'ppssc',
      width: '13%',
    },
    {
      label: 'Financial Segmentation',
      key: 'segmentation',
      width: '13%',
    },
    {
      label: 'Demand Planning',
      key: 'dpStrategy',
      width: '13%',
    },
  ];

  const toggleIsAllSelected = (sectionData: NDCTableInstanceInterfce) => {
    if (selectedNdcSectionContractNumber != sectionData.ContractNumber) {
      resetNdcSelectedIndexes();
      handleSetSelectedSectionContractNumber(sectionData.ContractNumber);
      const tempIndexes: number[] = [];
      sectionData.RowData.forEach((row, index) => {
        // addNdcIndexForMultiEdit(index, row.ContractNumber);
        tempIndexes.push(index);
      });
      handleSetNdcStrategyIndexes(tempIndexes);
    } else {
      if (checkNdcSectionAllSelected(sectionData)) {
        handleSetSelectedSectionContractNumber('');
      } else {
        handleSetSelectedSectionContractNumber('');
        handleSetSelectedSectionContractNumber(sectionData.ContractNumber);
        const tempIndexes: number[] = [];
        sectionData.RowData.forEach((row, index) => {
          // addNdcIndexForMultiEdit(index, row.ContractNumber);
          tempIndexes.push(index);
        });
        handleSetNdcStrategyIndexes(tempIndexes);
      }
    }
  };

  const handleMultiEditButtonClick = (accordionIndex: number) => {
    setSelectedContractAccordionIndex(accordionIndex);
    if (selectedNdcStrategyIndexesForEdit.length === 1) {
      toggleNdcStrategyModalVisibility();
      const rowIndex = selectedNdcStrategyIndexesForEdit[0];
      handleEditSingleNdcStrategy(rowIndex, ndcSections()[accordionIndex].RowData[rowIndex]);
    } else if (selectedNdcStrategyIndexesForEdit.length > 1) {
      toggleNdcBulkEditStrategyModal();
    }
  };

  const checkNdcSectionAllSelected = (sectionData: NDCTableInstanceInterfce) => {
    if (selectedNdcStrategyIndexesForEdit.length === sectionData.RowData.length) {
      return true;
    }
    return false;
  };

  return {
    columnDetails,
    ndcSections,
    ndcTablesData,
    setIsAllSelected,
    isConceptsListLoading,
    checkNdcSectionAllSelected,
    selectedContractAccordionIndex,
    setSelectedContractAccordionIndex,
    toggleIsAllSelected,
    isBulkEditModalVisible,
    toggleNdcBulkEditStrategyModal,
    selectedNdcSectionContractNumber,
    isNcdTableLoading,
    isNdcStrategyModalVisible,
    selectedNdcStrategyIndexesForEdit,
    addNdcIndexForMultiEdit,
    handleEditSingleNdcStrategy,
    handleViewSingleNdcStrategy,
    handleAddSingleNdcStrategy,
    toggleNdcStrategyModalVisibility,
    checkIfNdcIndexIsSelected,
    handleMultiEditButtonClick,
    isNDCAddVisible,
    isNDCViewVisible,
    toggleNDCAddModalVisibility,
    toggleNDCViewModalVisibility,
    userModulesRoles,
    checkIfFunctionalityEnabled,
    ndcAllowedRoles,
  };
};
